var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('option',{domProps:{"value":_vm.address}},[_vm._v("\n  "+_vm._s(_vm.addressTemplate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }